import { UserDataForm } from '@/packages/courses/components/user-data-form';
import { CreditCardDetailsStep } from '@/packages/courses/pages/checkout/steps/credit-card-details';
import { CreditCardInstallmentsStep } from '@/packages/courses/pages/checkout/steps/credit-card-installments';
import { DataConfirmationStep } from '@/packages/courses/pages/checkout/steps/data-confirmation';
import { PaymentMethodStep } from '@/packages/courses/pages/checkout/steps/payment-method';
import { PaymentStatusStep } from '@/packages/courses/pages/checkout/steps/payment-status';
import { PixBankSlipStep } from '@/packages/courses/pages/checkout/steps/pix-bank-slip';
import { CheckoutStepIds } from '@/packages/courses/pages/checkout/types';

export const checkoutSteps = {
  [CheckoutStepIds.CustomerInfo]: { component: UserDataForm },
  [CheckoutStepIds.PaymentMethod]: { component: PaymentMethodStep },
  [CheckoutStepIds.CreditCardDetails]: { component: CreditCardDetailsStep },
  [CheckoutStepIds.CreditCardInstallments]: {
    component: CreditCardInstallmentsStep,
  },
  [CheckoutStepIds.DataConfirmation]: { component: DataConfirmationStep },
  [CheckoutStepIds.PixBankSlip]: { component: PixBankSlipStep },
  [CheckoutStepIds.PaymentStatus]: { component: PaymentStatusStep },
};
